export default "__VITE_ASSET__CDxsZ23W__"